import React, { Component } from 'react';
import '../css/Logo.css';

export default class Logo extends Component {
  render() {
    return <h6>Tunes</h6>;
  }
}
